import axios from 'axios'
import { NotificationVariableResponse } from '@/modules/configurationModule/detail/notifications/models/common'

class CustomNotificationVariablesService {
    async getAllCustomNotificationVariablesByCase(laboratoryId: number, caseId: number): Promise<NotificationVariableResponse[]> {
        const response = await axios.get(`/${laboratoryId}/cases/${caseId}/customNotificationVariables`)
        return response.data
    }
    async getAllCustomNotificationVariablesByNotificationType(code: string): Promise<NotificationVariableResponse[]> {
        const params = { type: code }
        const response = await axios.get(`/customNotificationVariables`, { params })
        return response.data
    }
}

export const customNotificationVariablesService = new CustomNotificationVariablesService()
